// JsFromRoutes CacheKey a64041090924063c3e20e17f51272d14
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/url-preview'),
}
